import { useQuasar, Notify } from 'quasar'
import { useI18n } from 'vue-i18n'

interface INotifyOptions {
  progress?: boolean
  color?: string
  textColor?: string
  icon?: string
  iconColor?: string
  iconSize?: string
  position?: 'bottom' | 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' | 'top' | 'left' | 'right' | 'center'
}

export default function useNotify() {
  const { t } = useI18n({ useScope: 'global' })
  const $q = useQuasar()

  Notify.registerType('rounded', {
    classes: 'rounded-32 fs-15px fw-500',
  })

  const notify = (
    isSuccess = true,
    message = '',
    options: INotifyOptions = {
      progress: false,
      color: '',
      textColor: '',
      icon: '',
      iconColor: '',
      iconSize: '',
      position: 'bottom',
    },
  ) => {
    if (isSuccess) {
      $q.notify({
        type: 'rounded',
        progress: options.progress,
        color: options.color || 'success-20',
        textColor: options.textColor || 'success-100',
        icon: options.icon ? options.icon : 'check_circle',
        iconColor: options.iconColor || 'success-70',
        iconSize: '24px',
        message: message || t('notify.success'),
        position: options.position,
      })
    } else {
      $q.notify({
        type: 'rounded',
        progress: options.progress,
        color: options.color || 'error-20',
        textColor: options.textColor || 'error-100',
        icon: options.icon ? options.icon : 'cancel',
        iconColor: options.iconColor || 'error-100',
        iconSize: '24px',
        message: message || t('notify.failed'),
        position: options.position,
      })
    }
  }

  return { notify }
}
